import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class GlossaryService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'glossary';

  list(filter?): Observable<GlossaryPostPutGetId[]> {
    const letter = filter.letter ? `l=${filter.letter}` : '';
    const params = `?${letter}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<GlossaryPostPutGetId[]>(uri, {headers: headers});
  }

  getById(id): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/id/' + id;
    const headers = new HttpHeaders()
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

  getBySlug(slug): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/' + slug;
    const headers = new HttpHeaders()
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }

}

interface GlossaryPostPutGetId {
  title_ru: string,
  title_be: string,
  slug: string,
  text_ru: string,
  text_be: string,
  created_at: string,
  updated_at: string,
  published: number,
  id?: number
}